import { createSlice } from "@reduxjs/toolkit";

// Get business data from localStorage if available
const getInitialBusiness = () => {
  try {
    const savedBusiness = localStorage.getItem('businessData');
    return savedBusiness ? JSON.parse(savedBusiness) : null;
  } catch (error) {
    console.error('Error loading business from localStorage:', error);
    return null;
  }
};

const BusinessSlice = createSlice({
  name: "Business",
  initialState: {
    business: getInitialBusiness(),
    loading: false,
    error: null,
  },
  reducers: {
    setBusiness: (state, action) => {
      console.log('Setting business in Redux:', action.payload);
      state.business = action.payload;
      state.loading = false;
      state.error = null;
      
      // Save to localStorage
      try {
        localStorage.setItem('businessData', JSON.stringify(action.payload));
      } catch (error) {
        console.error('Error saving business to localStorage:', error);
      }
    },
    setBusinessLoading: (state, action) => {
      state.loading = action.payload;
    },
    setBusinessError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearBusiness: (state) => {
      state.business = null;
      state.loading = false;
      state.error = null;
      
      // Remove from localStorage
      try {
        localStorage.removeItem('businessData');
      } catch (error) {
        console.error('Error removing business from localStorage:', error);
      }
    },
  },
});

export const {
  setBusiness,
  setBusinessLoading,
  setBusinessError,
  clearBusiness,
} = BusinessSlice.actions;

export default BusinessSlice.reducer; 